/**
 * 分类选择组件
 * @description 分类选择组件
 * @copy to  @author mll
 * @date 2020-5-27
 */
import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer } = framework_tool;
let {
    WizSelect,
    WizModal,
    WizTreeSelectList,
} = component_tool;

class WizClassifySelectRe extends WizContainer {

    componentName = 'WizClassifySelectRe';

    constructor(props) {
        super(props);
        this.state = {
            stateSelects: props.initSelects,
            rowData: new Date().getTime(),
        }
        this.defaultValue = props.initSelects;
    }

    static defaultProps = {
        onChange: () => { },//点击modal 确定的回调方法
        value: [],//已选数据,
        modalProps: {},//modal的参数
        selectProps: {},//输入框的参数
        wizTreeSelectListProps: {},//WizTreeSelectList的参数
        apiProps: {},//调用分类接口的参数
        apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
        returnKey: false,//onChange返回数据是否需要key，默认返回对象
    };


    /**
     * 初始化时根据record判断是新增还是编辑
     */
    _componentDidMount() {
        let { apiProps, apiPath, initSelects, returnKey, onChange } = this.props
        if (initSelects && initSelects.length > 0) {
            this.setState({ stateSelects: initSelects })
            let _stateSelects = [...initSelects]
            onChange && onChange(
                returnKey ?
                    _stateSelects.map(select => select.key)
                    :
                    _stateSelects
            );
        }
        if (this.props.onClearWiz) {
            this.props.onClearWiz(this._onClear.bind(this))

        }
        this.doActions([
            {
                path: apiPath,
                payload: {
                    key: `questionType@treeData`,
                    apiParams: { state: 1, ...apiProps }
                }
            }
        ])
    }

    propsAndStateOnChange = {
        treeData: this._getDataOver.bind(this),
        value: this._valueChange.bind(this)
    }

    _valueChange(nextProps, nextState) {
        let { value } = nextProps;
        if (!value || !value.length) {
            nextState['stateSelects'] = []
            nextState['rowData'] = new Date().getTime()
        }
        return true;
    }
    _getDataOver(nextProps, nextState) {
        if (nextProps.treeData.code == 1) {
            if (nextProps.treeData.data && (nextProps.treeData.data instanceof Array)) {
                nextProps.treeData.data.forEach(data => {
                    this.giveKey(data)
                });
            }
        } else {
            nextProps.treeData.data = [];
        }
        return true;
    }

    _onClear = (isReset = true) => {
        this.setState({ stateSelects: this.defaultValue, rowData: new Date().getTime() })
    }

    /**给数据加key */
    giveKey(data) {
        data.key = data.value;
        if (data.children && data.children instanceof Array) {
            data.children.forEach(children => {
                this.giveKey(children)
            })
        }
    }

    _treeSelectOnClick() {
        this.setState({
            modalVisible: true,
        });
    }



    _wizSelectOnSubmit() {
        let { returnKey, onChange } = this.props
        let { stateSelects } = this.state
        let _stateSelects = [...stateSelects]
        this.setState({
            modalVisible: false,
            rowData: new Date().getTime(),
        }, () => {
            onChange && onChange(
                returnKey ?
                    _stateSelects.map(select => select.key)
                    :
                    _stateSelects
            );
        });
    }

    _wizSelectOnCancel() {
        let { stateSelects } = this.state
        let { returnKey, value, treeData, keepPreviousVal = false } = this.props
        let _stateSelects = []
        if (returnKey) {
            value.forEach(v => {
                stateSelects.forEach(s => {
                    if (v === s['key']) {
                        _stateSelects.push(s)
                    }
                });
            });

            /**
             * 编辑进入时,如点击tree内容-取消，会使数据情况 (测试理解为bug)
             * 在此加入补偿逻辑,将value与整个树进行匹配 (用于话术)
             */
            if (keepPreviousVal && value && value.length !== 0) {
                let allTreeArr = []
                // 递归树结构
                const setTreeRecursion = (data) => {
                    data.map((item, index) => {
                        let { key, title, value } = item
                        allTreeArr.push({
                            key,
                            title,
                            value
                        })
                        if (item.children && item.children.length != 0) {
                            setTreeRecursion(item.children);
                        }
                    });
                }
                setTreeRecursion(treeData.data || [])
                // 重置数据
                _stateSelects = []
                // 匹配
                value.forEach(v => {
                    allTreeArr.forEach(s => {
                        if (v == s['key']) {
                            _stateSelects.push(s)
                        }
                    });
                });
            }
        } else {
            _stateSelects = value
        }
        this.setState({
            modalVisible: false,
            rowData: new Date().getTime(),
            stateSelects: _stateSelects
        });
    }

    _renderOptions(propsSelects) {
        if (propsSelects && propsSelects.length) {
            return propsSelects.map((row, i) => this._renderOption(row))
        }
        return null
    }

    _renderOption(row) {
        if (row) {
            return (
                <WizSelect.Option key={row['key']} value={row['title']} title={row['title']}>
                    {row['title']}
                </WizSelect.Option>
            )
        }
    }

    _wizSelectOnChange(value, option) {
        let classify = value.map(select => select.key)
        let stateSelects = this.state.stateSelects.filter(filter => classify.indexOf(filter.key) !== -1)
        this.setState({
            stateSelects: stateSelects,
            rowData: new Date().getTime(),
        }, () => {
            this.props.onChange(
                this.props.returnKey ?
                    classify
                    :
                    value
            );
        });
    }


    _render() {
        let { value, modalProps, wizTreeSelectListProps, selectProps, returnKey } = this.props
        const { modalVisible, stateSelects, rowData } = this.state

        let defaultValue = []
        if (returnKey) {
            stateSelects && stateSelects.forEach(s => {
                defaultValue.push({ key: s.key, label: s.title })
            });
        } else {
            defaultValue = value.map(select => { return { key: select.key, label: select.title } })
        }
        let treeData = this.props.treeData.data ? this.props.treeData.data : [];
        let selectKey = stateSelects && stateSelects.map(select => select.key).join(",")
        return (
            <>
                <div onClick={() => this._treeSelectOnClick()}>
                    <WizSelect
                        key={'wizSelect_' + selectKey}
                        mode={'multiple'}
                        placeholder={'请选择分类'}
                        labelInValue
                        {...selectProps}
                        defaultValue={defaultValue}
                        open={false}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                        {this._renderOptions(stateSelects)}
                    </WizSelect>
                </div>
                {treeData ?
                    <WizModal
                        title={'选择'}
                        width={1000}
                        {...modalProps}
                        visible={modalVisible}
                        maskClosable={false}
                        onOk={e => this._wizSelectOnSubmit(e)}
                        onCancel={e => this._wizSelectOnCancel(e)}
                    >
                        <WizTreeSelectList
                            key={'WizTreeSelectList_' + rowData}
                            {...wizTreeSelectListProps}
                            treeData={treeData}
                            checkedKeys={stateSelects && stateSelects.map(select => select.key)}
                            listCheck={stateSelects}
                            onChange={(selects) => {
                                this.setState({
                                    stateSelects: selects,
                                });
                            }}
                        />
                    </WizModal>
                    : null}
            </>)
    }
}

const mapStateToProps = (state, ownProps) => {
    const { questionType } = state;

    const treeData = modelUtils.getModelEntity(questionType, "questionType@treeData");
    const load = modelUtils.getLoadingState(state, "selects");

    return {
        treeData,
        ...load
    }
};

const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(WizClassifySelectRe);

